<template>
  <component :is="iconComponent" :class="[className, variant]" :style="customColorStyle" />
</template>

<script>
import { TimeOffsSettingsIconsMap } from '@/constants/TimeOffsSettingsIconsList'
import * as TimeOffSettingsIcons from '@/constants/TimeOffsSettingsIcons'

export default {
  name: 'TimeOffIcon',
  components: {
    ...TimeOffSettingsIcons
  },
  props: {
    name: {
      type: String,
      required: true
    },
    variant: {
      type: String,
      default: 'primary',
      validator (variant) {
        if (!variant) {
          return true
        }

        return ['primary', 'secondary', 'accent', 'white'].includes(variant)
      }
    },
    color: String,
    className: String
  },
  computed: {
    iconComponent () {
      if (!this.name) {
        throw new Error(`"${this.name}" icon is not found`)
      }

      return TimeOffsSettingsIconsMap[this.name]
    },
    customColorStyle () {
      return this.color ? { color: this.color } : {}
    }
  }
}
</script>

<style lang="scss" scoped>
.primary {
  color: $iconColorBase;
}

.secondary {
  color: $iconColor2;
}

.accent {
  color: $iconColorAccent;
}

.white {
  color: #fff;
}
</style>
